// action - state management
import * as actionTypes from "./actions";

const initialState = {
  sellerInfo: "",
  aufnrInfo: "",
  hkontInfo: "",
};

// ==============================|| EXPENSE REDUCER ||============================== //

const expenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SELLER:
      return { ...state, sellerInfo: action?.payload?.sellerInfo };
    case actionTypes.CHANGE_AUFNR:
      return { ...state, aufnrInfo: action?.payload?.aufnrInfo };
    case actionTypes.CHANGE_HKONT:
      return { ...state, hkontInfo: action?.payload?.hkontInfo };
    case actionTypes.GETCOMPANY_INFO:
      return { ...state, companyInfo: action.companyInfo };
    default:
      return state;
  }
};

export default expenseReducer;
